<template>
	<div class="paymentSaoma">
		<div class="header">
			<rs-row>
				<rs-col :span="24">
					<div class="grid-content bg-purple-dark">
						<span style="margin-left: 10px;font-weight: bold;font-size: 15px;">账单支付</span>
					</div>
				</rs-col>
			</rs-row>
		</div>
		<div class="main" style="margin-top: 50px;padding: 20px;height: 100%;" v-for="(item, index) in paylist">
			<div style="display: flex;justify-content: space-between;font-weight: bold;">
				<div>{{index+1}}.公司名称：{{item.companyName}}</div>
				<div v-if="link">支付状态：支付成功</div>
				<div v-if="lonk">支付状态：未支付</div>
			</div>
			 <rs-table
			 v-loading.fullscreen.lock="fullscreenLoading"
			    ref="singleTable"
			    :data="paylist[index].itemAccountReceivableVOList"
			    highlight-current-row
			    border
			    style="width: 100%;margin-top: 10px;">
			    <rs-table-column
				header-align='center'
				label='序号'
			      type="index"
			      width="50">
			    </rs-table-column>
			    <rs-table-column
			      property="boothCode"
				  header-align='center'
				  align='center' show-overflow-tooltip
			      label="铺位编号"
			      width="120">
			    </rs-table-column>
			    <rs-table-column
				header-align='center'
			      property="buildingName"
				  align='center' show-overflow-tooltip
			      label="楼栋"
			      width="120">
			    </rs-table-column>
			    <rs-table-column
				header-align='center'
			      property="floorName"
				  align='center' show-overflow-tooltip
			      label="楼层">
			    </rs-table-column>
				<rs-table-column
				header-align='center' 
				  align='center' show-overflow-tooltip
				  label="账单周期">
				  <template slot-scope="scope">
				  	{{scope.row.statementBeginEndTime }}
				  </template>
				</rs-table-column>
				<rs-table-column
				header-align='center'
				  property="settleDate"
				  align='center' show-overflow-tooltip
				  label="付款日期">
				</rs-table-column>
				<rs-table-column
				  property="unpaidAmount"
				  align='center' show-overflow-tooltip
				  header-align='center'
				  label="缴纳金额(元)">
				</rs-table-column>
				<rs-table-column
				  property="itemName"
				  header-align='center'
				  align='center' show-overflow-tooltip
				  label="费用项">
				</rs-table-column>
				<rs-table-column
				header-align='center'
				  property="contractCode"
				  align='center' show-overflow-tooltip
				  label="合同号">
				</rs-table-column>
			  </rs-table>
			 <div style="display: flex;justify-content: space-between;">
				 <div></div>
				 <div>  <ul style="width:550px;display: flex;flex-wrap:wrap ;line-height: 2em;height: 200px;font-weight: bold;">
			 					  <li style="width: 200px;">账号：{{item.accountNumber}}</li>
			 					  <li style="width: 350px;">商户订单号：{{item.merOrderNo}}</li>
			 					  <li style="width: 200px;">商户编号：{{item.merchantNumber}}</li>
			 					  <li style="width: 200px;">子账户名称：{{item.subActName}}</li>
			 					  <li style="width: 200px;">渠道子账户：{{item.chlSubActNo}}</li>
			 					  <li style="width: 200px;">合计金额：{{item.orderAmt}}</li>
			 					  <li style="width: 500px;">校验码：{{item.checkCode}}</li>
			 				  </ul></div>	
			 </div>
			 
		</div>
		<div class="fotter" style="padding: 20px;text-align: right;">
			<rs-button @click='close'>关闭</rs-button>
		</div>
	</div>
</template>

	<script>
		import utils from "@/utils/utils";
	import API from "@/api/pay";
	export default{
		data(){
			return{
				fullscreenLoading: false,
				tableData: [],
				paylist:[],
				merOrderNo:'',
				status:'',
				timer:'',
				link:false,
				lonk:true,
			}
		},
		created() {
			this.Pay()
		},
		methods:{
			//对公
			Pay(){
				this.fullscreenLoading = true;
				setTimeout(() => {
					this.fullscreenLoading = false;
				}, 2000);
				let phone = utils.getSession("shopVo");
				let params = {
					statementNo: this.$route.query.categoryList,
					itemCode: this.$route.query.classifystr,
					businessId:phone,
				};
				API.unifiedPreOrder9004(params).then((res) => {
					if (res.data.code == 200) {
						console.log("获取合同列表", res);
						this.paylist=res.data.data
					this.timer=setInterval(()=>{
						this.paylist.map((item)=>{
							this.merOrderNo=item.merOrderNo
							// this.timer=setInterval(()=>{
								this.getOrderlist()
							// },6000)
						})
							 },3000)
					} 
				});
			},
			//通过订单编号获取缴费记录
			getOrderlist(){
				let params = {
					merOrderNo: this.merOrderNo,
				};
				API.getPayRecordByMerOrderNo(params).then((res) => {
					if (res.data.code == 200) {
						console.log("获取合同列表", res.data.data.tradeStatus);
						this.status=res.data.data.tradeStatus
				if(res.data.data.tradeStatus=="SUCCESS"){
					clearInterval(this.timer)
					this.link=true,
					this.lonk=false
					// this.handleQuery()
				}else{
					this.lonk=true
					this.link=false
				}
					}
				});
			},
			close(){
				this.$router.back()
				clearInterval(this.timer)
			}
		}
	}
</script>

<style scoped="scoped" lang="less">
	@import "../../organizationManage/style/index.less";
	.rs-row {
		margin-bottom: 20px;
	
		&:last-child {
			margin-bottom: 0;
		}
	}
	
	
</style>
